var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLearnMore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 26,
    viewBox: "0 0 35 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.24 0.691467C27.7044 0.691467 30.0679 1.67046 31.8106 3.41308C33.5532 5.1557 34.5322 7.5192 34.5322 9.98364V16.1784C34.5322 18.6429 33.5532 21.0064 31.8106 22.749C30.0679 24.4916 27.7044 25.4706 25.24 25.4706H9.75305C7.28861 25.4706 4.92511 24.4916 3.18249 22.749C1.43987 21.0064 0.460876 18.6429 0.460876 16.1784V9.98364C0.460876 7.5192 1.43987 5.1557 3.18249 3.41308C4.92511 1.67046 7.28861 0.691467 9.75305 0.691467H25.24ZM25.24 3.78886H9.75305C8.16371 3.78886 6.63517 4.39972 5.48359 5.49509C4.332 6.59047 3.64548 8.08655 3.56601 9.6739L3.55827 9.98364V16.1784C3.55827 17.7678 4.16913 19.2963 5.2645 20.4479C6.35988 21.5995 7.85596 22.286 9.44331 22.3655L9.75305 22.3732H25.24C26.8293 22.3732 28.3579 21.7623 29.5095 20.667C30.661 19.5716 31.3476 18.0755 31.427 16.4882L31.4348 16.1784V9.98364C31.4348 8.3943 30.8239 6.86576 29.7286 5.71418C28.6332 4.56259 27.1371 3.87607 25.5497 3.7966L25.24 3.78886ZM14.3991 8.43495V11.5323H17.4965V14.6297H14.3976L14.3991 17.7271H11.3017L11.3002 14.6297H8.20435V11.5323H11.3017V8.43495H14.3991ZM26.7887 14.6297V17.7271H23.6913V14.6297H26.7887ZM23.6913 8.43495V11.5323H20.5939V8.43495H23.6913Z",
    fill: "url(#paint0_linear_3724_17100)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3724_17100",
    x1: 1.59215,
    y1: 0.0381108,
    x2: 23.2558,
    y2: 33.1967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#548CF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2663DA"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLearnMore);
export default __webpack_public_path__ + "static/media/learn-more.ea2d4cf4090ed74a4c59a670a3859dc8.svg";
export { ForwardRef as ReactComponent };